import { render, staticRenderFns } from "./GoodListCom.vue?vue&type=template&id=6244e048&scoped=true"
import script from "./GoodListCom.vue?vue&type=script&lang=js"
export * from "./GoodListCom.vue?vue&type=script&lang=js"
import style0 from "./GoodListCom.vue?vue&type=style&index=0&id=6244e048&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244e048",
  null
  
)

export default component.exports